import { lazy } from 'react'
import { IN_FREEZING } from 'core/common/constants/settings'

const Product = lazy(() => import('core/pages/Seller/Product'))
const ProductMatchSearch = lazy(() => import('core/pages/Seller/ProductMatchSearch'))
const ProductMatch = lazy(() => import('core/pages/Seller/ProductMatch'))
const ProductNew = lazy(() => import('core/pages/Seller/ProductNew'))
const ProductNewV2 = lazy(() => import('core/pages/ProductNew-v2'))
const ProductNewSimilar = lazy(() => import('core/pages/Seller/ProductNew/ProductNewSimilar'))
const ProductEdit = lazy(() => import('core/pages/Seller/ProductEdit'))
const ProductImport = lazy(() => import('core/pages/Seller/ProductImport'))
const ProductImportHistory = lazy(() => import('core/pages/Seller/ProductImportHistory'))
const ProductImportFailure = lazy(() => import('core/pages/Seller/ProductImportFailure'))
const ProductImproveScore = lazy(() => import('core/pages/ProductImproveScore'))
const PageFreezing = lazy(() => import('core/pages/Common/Freezing'))
const ProductIntroduction = lazy(() => import('core/pages/ProductNew-v2/ProductIntroduction'))
const ProductSearch = lazy(() => import('core/pages/ProductNew-v2/ProductMatchSearch'))
const ProductType = lazy(() => import('core/pages/ProductNew-v2/ProductType'))
const ProductCategory = lazy(() => import('core/pages/ProductNew-v2/ProductCategory'))
const ProductPerformance = lazy(() => import('core/pages/Seller/ProductPerformance'))
const ProductConfirmCategory = lazy(() => import('core/pages/ProductNew-v2/ProductConfirmCategory'))
const ProductEditNew = lazy(() => import('core/pages/ProductEditNew'))

const product = [
  {
    path: '/',
    component: Product,
    exact: true,
  },
  {
    path: '/search',
    component: IN_FREEZING ? PageFreezing : ProductMatchSearch,
    exact: true,
  },
  {
    path: '/new',
    component: IN_FREEZING ? PageFreezing : ProductNew,
    exact: true,
  },
  {
    path: '/:match_id/new',
    component: IN_FREEZING ? PageFreezing : ProductMatch,
    exact: true,
  },
  {
    path: '/:id/similar',
    component: IN_FREEZING ? PageFreezing : ProductNewSimilar,
    exact: true,
  },
  {
    path: '/:id/edit',
    component: ProductEdit,
    exact: true,
  },
  {
    path: '/import',
    component: IN_FREEZING ? PageFreezing : ProductImport,
    exact: true,
  },
  {
    path: '/import/history',
    component: ProductImportHistory,
    exact: true,
  },
  {
    path: '/import/:id/failure',
    component: ProductImportFailure,
    exact: true,
  },
  {
    path: '/relevancia/atualizar/:id',
    component: ProductImproveScore,
    exact: true,
  },
  {
    path: '/novo-produto',
    component: ProductNewV2,
    exact: true,
  },
  {
    path: '/novo-produto/introducao',
    component: ProductIntroduction,
    exact: true,
  },
  {
    path: '/novo-produto/search',
    component: ProductSearch,
    exact: true,
  },
  {
    path: '/novo-produto/escolher-tipo-de-produto',
    component: ProductType,
    exact: true,
  },
  {
    path: '/novo-produto/escolher-categoria-de-produto',
    component: ProductCategory,
    exact: true,
  },
  {
    path: '/novo-produto/confirmar-categoria-de-produto',
    component: ProductConfirmCategory,
    exact: true,
  },
  {
    path: '/desempenho/:id',
    component: ProductPerformance,
    exact: true,
  },
  {
    path: '/editar/:productId',
    component: ProductEditNew,
    exact: true,
  },
]

export default product
